import {rootApi} from 'src/models';

const api = rootApi.injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    getResellers: builder.query<{id: number; name: string}[], void>({
      query: () => ({
        method: 'GET',
        url: '/tenantmanagement/reseller',
        meta: {isShowError: true},
      }),
    }),
  }),
});

export const {useGetResellersQuery} = api;
